import { render, staticRenderFns } from "./TicketsFollow.vue?vue&type=template&id=69055a10&scoped=true"
import script from "./TicketsFollow.vue?vue&type=script&lang=js"
export * from "./TicketsFollow.vue?vue&type=script&lang=js"
import style0 from "./TicketsFollow.vue?vue&type=style&index=0&id=69055a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69055a10",
  null
  
)

export default component.exports